import { Alert, Button, Checkbox, Collapse, Form, Input, Modal, notification, Select, Space, Table, Tag, Typography } from 'antd'
import React, { Component } from 'react'
import { PricingAPI } from '../../../controller/PricingAPI';
import DeleteModal from '../../components/DeleteModal'

export class NotificationSettingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recipientLoading: false,
            recipients: [],
            recipientEditMode: 'store',
            showEditRecipientModal: false,

            groups: [],
            notificationTypes: [],
            groupLoading: false,
            showEditGroupModal: false,
            groupEditMode: 'store',
            groupId: null,
        }
        this.recipientForm = React.createRef();
        this.deleteRecipientModel = React.createRef();
        this.groupForm = React.createRef();
        this.deleteGroupModel = React.createRef();
    }
    componentDidMount() {
        this.fetchEmailRecipients();
        this.fetchGroups();
        this.fetchNotificationTypes();
    }
    fetchEmailRecipients = () => {
        this.setState({ recipientLoading: true });
        PricingAPI.mail.recipitents.index({}, 1, 999).then((response) => {
            const result = response.data;
            this.setState({ recipients: result.data });
        }).finally(() => {
            this.setState({ recipientLoading: false });
        });
    }
    fetchGroups = () => {
        this.setState({ groupLoading: true });
        PricingAPI.mail.groups.index().then((response) => {
            this.setState({ groups: response.data });
        }).finally(() => {
            this.setState({ groupLoading: false });
        });
    }
    fetchNotificationTypes = () => {
        PricingAPI.mail.notificationTypes.index().then((response) => {
            this.setState({ notificationTypes: response.data });
        });
    }
    showEditRecipientModal = (id) => {
        // 模式與 id 必須同步設定：舊寫法把 recipientEditMode 設在 fetchRecipient()
        // 的非同步回呼裡且從不設回，導致「修改某人之後再按新增」會沿用上一次的
        // 編輯模式與 id，把新輸入的內容覆寫到前一位收件人身上，連他的群組訂閱
        // 一起換掉 - 那正是這個功能要消除的「有人安靜地失去通知」。
        this.setState({ showEditRecipientModal: true, recipientEditMode: id ? 'edit' : 'store', recipientId: id || null });

        if (id) {
            this.fetchRecipient(id);
        } else {
            this.recipientForm.current && this.recipientForm.current.resetFields();
        }
    }
    hideEditRecipientModal = () => {
        this.setState({ showEditRecipientModal: false })
    }
    fetchRecipient = (id) => {
        if (!id) return;
        PricingAPI.mail.recipitents.show(id).then((response) => {
            const result = response.data;
            console.log(result);
            this.recipientForm.current.setFieldsValue({
                ...result,
                group_ids: (result.groups || []).map((g) => g.id),
            });
        });
    }
    /**
     * Email 填完就把系統使用者的姓名帶進名字欄 —— 名字是必填的，而多數收件者
     * 就是系統裡的人，讓他們再打一次是白工。
     *
     * 只在名字還空著時補，而且非同步回來時要再確認一次：使用者在等待期間
     * 自己打的字不能被蓋掉。
     */
    suggestRecipientName = (event) => {
        const address = (event.target.value || '').trim();
        const form = this.recipientForm.current;

        if (!address || !form || form.getFieldValue('name')) return;

        PricingAPI.mail.recipitents.suggestName(address).then((response) => {
            if (response.data.name && !form.getFieldValue('name')) {
                form.setFieldsValue({ name: response.data.name });
            }
        }).catch(() => {
            // 對不上就算了 —— 這只是省打字，不是必要步驟，沒必要打擾使用者
        });
    }
    handleEditRecipient = (values) => {
        if (this.state.recipientEditMode === 'store') {
            this.setState({ recipientLoading: true });
            PricingAPI.mail.recipitents.store(values).then((response) => {
                notification.info({ message: '新增成功' });
                this.recipientForm.current.setFieldsValue({ address: null });
                this.fetchEmailRecipients();
                this.fetchGroups();
                this.hideEditRecipientModal();
            }).catch((error) => {
                // 攔截器只處理 401，422 (例如地址重複) 等其餘狀態碼不會有任何回饋，
                // 要自己接住才不會是一個無聲的 unhandled rejection。
                notification.error({
                    message: (error.response && error.response.data && error.response.data.message) || '儲存失敗',
                });
            }).finally(() => {
                this.setState({ recipientLoading: false });
                // covered 現在看的是「群組有沒有成員」，新增收件人也可能讓某個
                // 通知類型從無人接收變成有人接收，警示要跟著重新整理。
                this.fetchNotificationTypes();
            });
        } else {
            this.setState({ recipientLoading: true });
            PricingAPI.mail.recipitents.update(this.state.recipientId, values).then((response) => {
                notification.info({ message: '修改成功' });
                this.recipientForm.current.setFieldsValue({ address: null });
                this.fetchEmailRecipients();
                this.fetchGroups();
                this.hideEditRecipientModal();
            }).catch((error) => {
                notification.error({
                    message: (error.response && error.response.data && error.response.data.message) || '儲存失敗',
                });
            }).finally(() => {
                this.setState({ recipientLoading: false });
                this.fetchNotificationTypes();
            });
        }
    }
    handleRecipientModalOk = () => {
        this.recipientForm.current.submit();
    }
    handleDeleteRecipient = (id) => {
        this.setState({ loading: true });
        PricingAPI.mail.recipitents.destroy(id).then((response) => {
            console.log("handleDelete", id, response);
            notification.info({
                message: "刪除成功"
            });
        }).catch((error) => {
            // 攔截器只處理 401，其餘狀態碼不處理，要自己接住才有訊息。
            notification.error({
                message: (error.response && error.response.data && error.response.data.message) || '刪除失敗',
            });
        }).finally(() => {
            this.setState({ loading: false });
            this.fetchEmailRecipients();
            this.fetchGroups();
            // 刪掉收件人可能讓他所屬群組唯一的成員消失，某個通知因此變成無人接收。
            this.fetchNotificationTypes();
        });
    }
    showEditGroupModal = (id) => {
        this.setState({ showEditGroupModal: true, groupEditMode: id ? 'edit' : 'store', groupId: id });
        if (id) {
            PricingAPI.mail.groups.show(id).then((response) => {
                this.groupForm.current.setFieldsValue(response.data);
            });
        } else {
            this.groupForm.current && this.groupForm.current.resetFields();
        }
    }
    hideEditGroupModal = () => {
        this.setState({ showEditGroupModal: false });
    }
    handleGroupModalOk = () => {
        this.groupForm.current.submit();
    }
    handleEditGroup = (values) => {
        const payload = {
            name: values.name,
            notification_types: values.notification_types || [],
            recipient_ids: values.recipient_ids || [],
        };
        const request = this.state.groupEditMode === 'store'
            ? PricingAPI.mail.groups.store(payload)
            : PricingAPI.mail.groups.update(this.state.groupId, payload);

        this.setState({ groupLoading: true });
        request.then(() => {
            notification.info({ message: this.state.groupEditMode === 'store' ? '新增成功' : '修改成功' });
            this.hideEditGroupModal();
            this.groupForm.current.resetFields();
            this.fetchGroups();
            this.fetchNotificationTypes();
            this.fetchEmailRecipients();
        }).catch((error) => {
            // 攔截器只處理 401，422 (例如群組名稱重複、通知代碼未註冊) 等其餘狀態碼
            // 不會有任何回饋，要自己接住才不會是一個無聲的 unhandled rejection。
            notification.error({
                message: (error.response && error.response.data && error.response.data.message) || '儲存失敗',
            });
        }).finally(() => {
            this.setState({ groupLoading: false });
        });
    }
    handleDeleteGroup = (id) => {
        PricingAPI.mail.groups.destroy(id).then(() => {
            notification.info({ message: '刪除成功' });
        }).catch((error) => {
            // 攔截器只處理 401，其餘狀態碼不處理，要自己接住才有訊息。
            notification.error({
                message: (error.response && error.response.data && error.response.data.message) || '刪除失敗',
            });
        }).finally(() => {
            this.fetchGroups();
            this.fetchNotificationTypes();
            this.fetchEmailRecipients();
        });
    }

    render() {
        const columns = [
            {
                title: '名字',
                dataIndex: 'name',
                key: 'name',
                width: 140,
                render: (text) => text || <Typography.Text type="secondary">(未填)</Typography.Text>
            },
            {
                title: 'E-mail',
                dataIndex: 'address',
                key: 'address',
                width: 240,
                render: (text, record) => <Typography.Link onClick={this.showEditRecipientModal.bind(this, record.id)}>{text}</Typography.Link>
            },
            {
                title: '所屬群組',
                dataIndex: 'groups',
                key: 'groups',
                width: 260,
                render: (groups) => (groups || []).length
                    ? groups.map((g) => <Tag key={g.id}>{g.name}</Tag>)
                    : <Typography.Text type="secondary">未加入任何群組，收不到信</Typography.Text>
            },
            {
                title: '動作',
                key: 'action',
                width: 120,
                render: (text, record) => (
                    <Space size="middle">
                        <Typography.Link onClick={this.showEditRecipientModal.bind(this, record.id)}>修改</Typography.Link>
                        <Typography.Link onClick={this.deleteRecipientModel.current.confirmDelete.bind(this, record.id)}>刪除</Typography.Link>
                    </Space>
                ),
            },
        ];
        const typeLabel = (code) => (this.state.notificationTypes.find((t) => t.code === code) || {}).label || code;
        const groupColumns = [
            { title: '群組名稱', dataIndex: 'name', key: 'name', width: 160 },
            {
                title: '收到的通知',
                dataIndex: 'notification_types',
                key: 'notification_types',
                width: 420,
                render: (types) => (types || []).length
                    ? types.map((code) => <Tag key={code}>{typeLabel(code)}</Tag>)
                    : <Typography.Text type="secondary">未勾選任何通知</Typography.Text>
            },
            {
                title: '成員數',
                dataIndex: 'recipients_count',
                key: 'recipients_count',
                width: 100,
                render: (count) => count > 0 ? count : <Typography.Text type="secondary">0</Typography.Text>
            },
            // 群組表格的刪除刻意不用 .bind() 立刻解參考 (對照收件人表格「動作」欄的寫法)：
            // .bind() 會在 render 當下就對 deleteGroupModel.current 取屬性，一旦這個 Table
            // 在 DeleteModal 的 ref 還沒 commit 完成前就先以非空資料列渲染 (例如面板哪天又被
            // 改回延遲掛載、或掛載當下資料已經到位)，就會因為 current 仍是 null 而丟出
            // TypeError，讓整個面板連同 ErrorBoundary 一起壞掉。改成點擊當下才解參考，
            // 這個安全性就不必依賴「掛載當下資料一定是空的」這種容易被 defaultActiveKey
            // 調整而破壞的前提 - 收件人表格的「動作」欄目前還是靠這個前提撐著，見下方
            // defaultActiveKey 的註解。
            {
                title: '動作',
                key: 'action',
                width: 120,
                render: (text, record) => (
                    <Space size="middle">
                        <Typography.Link onClick={this.showEditGroupModal.bind(this, record.id)}>修改</Typography.Link>
                        <Typography.Link onClick={() => this.deleteGroupModel.current.confirmDelete(record.id)}>刪除</Typography.Link>
                    </Space>
                ),
            },
        ];
        // 只有會寄通知的排程才能被群組選；只建待辦的屬於部門，不該出現在這裡。
        const notifyTypes = this.state.notificationTypes.filter((t) => t.notifies);
        // render 內只算一次：JSX 裡原本各用了一次同樣的 filter，資料量雖小，
        // 但兩處各自重算沒有必要，也容易在改動時漏改其中一處。
        const uncoveredTypes = notifyTypes.filter((t) => !t.covered);

        return (
            <div>
                <h1>通知設定</h1>
                {/* defaultActiveKey 必須包含 1：收件人表格「動作」欄的刪除用的是 .bind()，
                    在 render 當下就對 deleteRecipientModel.current 取屬性。它現在不會崩，
                    是因為面板 1 從一開始就展開，元件掛載的當下 recipients 還是空陣列
                    (fetchEmailRecipients() 尚未回來)，Table 不會呼叫到任何一列的 render，
                    等資料真的到位時 DeleteModal 的 ref 早已 commit 完成。若把 1 拿掉，
                    使用者在資料已經到位後才手動展開面板，就會在 DeleteModal 掛載的同一次
                    render 裡對 .current 取屬性而丟出 TypeError。2 也要預設展開 (通知群組
                    的警示原本讓面板預設收合看不到)，不是拿來取代 1。 */}
                <Collapse defaultActiveKey={[1, 2]}>
                    <Collapse.Panel key={1} header="收件人">
                        <Button type="primary" onClick={this.showEditRecipientModal.bind(this, null)}>
                            新增
                        </Button>
                        <Table columns={columns} dataSource={this.state.recipients} rowKey="id" scroll={{ x: 'max-content' }} size="small" />
                        <Modal
                            title={`${this.state.recipientEditMode === 'store' ? "新增" : "修改"}收件者`}
                            visible={this.state.showEditRecipientModal}
                            onOk={this.handleRecipientModalOk}
                            onCancel={this.hideEditRecipientModal}
                            okText={this.state.recipientEditMode === 'store' ? "新增" : "修改"}
                            cancelText="取消"
                        >
                            <Form ref={this.recipientForm} onFinish={this.handleEditRecipient} labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
                                <Form.Item label="Email" name="address" rules={[{ required: true, type: 'email', message: '請填寫有效的 Email' }]}>
                                    <Input onBlur={this.suggestRecipientName} />
                                </Form.Item>
                                <Form.Item label="名字" name="name" rules={[{ required: true, message: '請填寫名字' }]}>
                                    <Input placeholder="系統使用者會依 Email 自動帶入" />
                                </Form.Item>
                                <Form.Item label="所屬群組" name="group_ids">
                                    <Select mode="multiple" allowClear placeholder="不加入任何群組就收不到信">
                                        {this.state.groups.map((g) => <Select.Option key={g.id} value={g.id}>{g.name}</Select.Option>)}
                                    </Select>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <DeleteModal ref={this.deleteRecipientModel} title="收件者" onDelete={this.handleDeleteRecipient} />
                    </Collapse.Panel>
                    <Collapse.Panel key={2} header="通知群組">
                        {uncoveredTypes.length > 0 && (
                            <Alert
                                type="warning"
                                showIcon
                                style={{ marginBottom: 16 }}
                                message="以下通知目前沒有任何人會收到"
                                description={uncoveredTypes.map((t) => t.label).join('、')}
                            />
                        )}
                        <Button type="primary" onClick={this.showEditGroupModal.bind(this, null)}>
                            新增群組
                        </Button>
                        <Table
                            columns={groupColumns}
                            dataSource={this.state.groups}
                            rowKey="id"
                            loading={this.state.groupLoading}
                            scroll={{ x: 'max-content' }}
                            size="small"
                        />
                        <Modal
                            title={`${this.state.groupEditMode === 'store' ? "新增" : "修改"}群組`}
                            visible={this.state.showEditGroupModal}
                            onOk={this.handleGroupModalOk}
                            onCancel={this.hideEditGroupModal}
                            okText={this.state.groupEditMode === 'store' ? "新增" : "修改"}
                            cancelText="取消"
                            width={640}
                        >
                            <Form ref={this.groupForm} onFinish={this.handleEditGroup} labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
                                <Form.Item label="群組名稱" name="name" rules={[{ required: true, message: '請填寫群組名稱' }]}>
                                    <Input />
                                </Form.Item>
                                <Form.Item label="收到的通知" name="notification_types">
                                    <Checkbox.Group>
                                        {notifyTypes.map((t) => (
                                            <div key={t.code}>
                                                <Checkbox value={t.code}>
                                                    {t.label}
                                                    <Typography.Text type="secondary" style={{ marginLeft: 8 }}>{t.frequency}</Typography.Text>
                                                </Checkbox>
                                            </div>
                                        ))}
                                    </Checkbox.Group>
                                </Form.Item>
                                <Form.Item label="成員" name="recipient_ids">
                                    <Select mode="multiple" allowClear placeholder="沒有成員的群組不會寄給任何人">
                                        {this.state.recipients.map((r) => (
                                            <Select.Option key={r.id} value={r.id}>{r.name ? `${r.name} (${r.address})` : r.address}</Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <DeleteModal ref={this.deleteGroupModel} title="群組" onDelete={this.handleDeleteGroup} />
                    </Collapse.Panel>
                </Collapse>

            </div>
        )
    }
}

export default NotificationSettingPage